module.exports = __webpack_public_path__ + "img/9422cb5.jpg";